// Images
import BuildImage1 from "../../assets/images/compressed-images/adobestock_1677951508.jpg";
import BuildImage2 from "../../assets/images/compressed-images/adobestock_833550483.jpg";
import BuildImage3 from "../../assets/images/compressed-images/adobestock_1634734956.jpg";
import BuildImage4 from "../../assets/images/compressed-images/adobestock_224006801.jpg";

const buildOfferings = [
  {
    title: "Data & AI.",
    image: BuildImage4,
    showLogo: true,
  },
  {
    title: "Digital Product\nInnovation & Growth.",
    image: BuildImage3,
  },
  {
    title: "AI Systems\nModernization.",
    image: BuildImage2,
  },
  {
    title: "Cloud Platforms\n& DevSecOps.",
    image: BuildImage1,
  },
];

const BuildOfferings = () => {
  return (
    <section
      id="What-we-build"
      className="flex flex-col gap-8 pt-20 md:pt-[88px] min-h-[90vh]"
    >
      <div className="flex flex-col gap-6">
        <div className="flex flex-row flex-wrap xl:flex-nowrap gap-1 rounded-xl overflow-hidden border border-gray-300">
          {buildOfferings.map((offering) => (
            <div
              key={offering.title}
              className="relative flex-1 min-w-[160px] h-96 md:h-[32rem]"
            >
              <img
                src={offering.image}
                alt={offering.title}
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
              <p className="absolute bottom-4 left-4 text-white text-base md:text-lg font-semibold leading-snug text-left">
                {offering.title.split("\n").map((line, i) => (
                  <span key={i}>
                    {line}
                    <br />
                  </span>
                ))}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BuildOfferings;
